import { Field, Role, ROLE_RANK, SchemaAction } from '../schema';

export interface GatingContext {
  role: Role;
  permissions: string[];
}

export const meetsRole = (required: Role | undefined, current: Role) => {
  if (!required) return true;
  return ROLE_RANK[current] >= ROLE_RANK[required];
};

export const meetsPermissions = (required: string[] | undefined, held: string[]) => {
  if (!required || required.length === 0) return true;
  return required.every((p) => held.includes(p));
};

export const canViewField = (field: Field, ctx: GatingContext): boolean => {
  return meetsRole(field.required_role, ctx.role) && meetsPermissions(field.required_permissions, ctx.permissions);
};

export const canRunAction = (action: SchemaAction, ctx: GatingContext): boolean => {
  return meetsRole(action.required_role, ctx.role) && meetsPermissions(action.required_permissions, ctx.permissions);
};
